<template>
	<div>
		<navTitle><div class="pageTitle">考官认证</div></navTitle>
		<div class="error" v-if="status == -1">
			失败原因：{{cause}}
		</div>
		<div class="applyForm">
			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left">姓名</div>
				<input :disabled="[1,2].includes(status)" type="text" class="input flex-1" placeholder="请输入真实姓名" maxlength="20" v-model.trim="truename" />
			</div>
			
			<div class="applyForm-line flex flex-align-center flex-jus-between" @click="[1,2].includes(status) ? '' : professionPopShow = true">
				<div class="left">专业领域</div>
				<div class="flex-1 right" v-if="professionListSelect.length == 0">请选择</div>
				<div class="flex-1 right flex flex-align-center flex-row-reverse" v-else>
					<div class="right-item" v-for="(item, index) in professionListSelect" :key="index">{{ item }}</div>
				</div>
			
				<img src="@/static/images/icon-arrowRight.png" class="arrow" />
			</div>
			
			<!-- 教学成果 -->
			<div class="applyForm-col">
				<div class="title">教学成果</div>
				<div class="textList"><textarea :disabled="[1,2].includes(status)" v-model="teaching_achievements" name="" placeholder="请输入描述说明您的教学成果......" maxlength="500" ></textarea></div>
			</div>
			
			<!-- 奖项凭证 -->
			<div class="applyPicTitle">
				考官执考证书
			</div>
			
			<van-uploader :disabled="[1,2].includes(status)" :deletable="status != 2 && status != 1" v-model="fileList" multiple :max-count="9" />
			
			<div v-if="status != 2 && status != 1" @click="submit" class="submitBtn">提交</div>
		</div>
		<!-- 专业领域弹窗 -->
		<van-popup v-model="professionPopShow" round position="bottom" :safe-area-inset-bottom="true">
			<div class="professionPop">
				<div class="title flex flex-align-center ">
					<div class="title-cancel" @click="professionPopShow = false">取消</div>
					<div class="title-content flex-1">请选择擅长的专业领域</div>
					<div class="title-confirm" @click="confirmPro">确定</div>
				</div>

				<div class="tips">最多支持选择3个擅长的专业领域</div>

				<div class="selectList flex flex-wrap flex-align-center">
					<div class="item" v-for="(item, index) in professionList" :key="index" @click="proSelec(index)" :class="{ 'item-active': professionListCheck[index] }">{{ item.name }}</div>
				</div>
			</div>
		</van-popup>
		<div v-if="loading" class="mask flex flex-align-center flex-jus-center">
			<div style="text-align:center">
				<van-loading size="36" color="#FFF"/>
				<div style="color:#fff;font-size:18px">
					资料提交中...
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		data() {
			return{
				status: null,
				loading: false,
				truename: '',
				cause: '',
				// 专业领域弹窗
				professionPopShow: false,
				professionList: [],
				professionListCheck: [],
				professionListCount: 0,
				professionListSelect: [], // 选择的专业领域的数组
				professionListIdSelect: [], // 选择的专业领域的id数组
				major_ids: '',

				teaching_achievements: '',

				// 奖项凭证
				fileList: [],
				imgList: []
			}
		},
		created() {
			this.status = Number(this.$route.query.status)
			this.getProfessionList()
			this.getData()
		},
		mounted() {
			// this.$wx.ready(() => {
			// 	this.$wx.updateAppMessageShareData({
			// 		title: '福建省民族管弦乐学会',
			// 		desc: '认证考官',
			// 		link: location.href,
			// 		imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
			// 	})
			// 	this.$wx.updateTimelineShareData({
			// 		title: '福建省民族管弦乐学会',
			// 		link: location.href,
			// 		imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
			// 	})
			// });
		},
		methods: {
			// 获取认证信息
			getData() {
				this.$get('api/user/getCertification', {
					type: 2
				}).then(res => {
					let result = res.data
					this.truename = result.truename
					this.teaching_achievements = result.teaching_achievements
					this.cause = result.cause
					if (result.certificates) {
						this.fileList = result.certificates.map(item => {
							return {
								url: item
							}
						})
					}
					if (result.major_ids) {
						this.professionListIdSelect = result.major_ids.split(',')
						this.professionListCount = this.professionListIdSelect.length
					}
					setTimeout(() => {
						this.professionListSelect = this.professionList.filter(item => this.professionListIdSelect.includes(String(item.id))).map(item=> {return item.name})
						for (let i = 0;i<this.professionList.length;i++) {
							let ind = this.professionListIdSelect.findIndex(item => item == this.professionList[i].id)
							if (ind>-1) {
								this.$set(this.professionListCheck, `${i}`, !this.professionListCheck[i]);
							}
						}
					}, 100);
				})
			},
			// 获取专业领域
			getProfessionList() {
				this.$get('api/common/getMajorIds').then(res => {
					this.professionList = res.data
				})
			},
			// 专业领域 确认
			confirmPro() {
				this.professionListSelect = [];
				this.professionListIdSelect = [];
				for (let i in this.professionList) 
					if (this.professionListCheck[i]) {
						this.professionListIdSelect.push(this.professionList[i].id);
						this.professionListSelect.push(this.professionList[i].name);
					} 
				this.professionPopShow = false;
			},
			// 专业领域选择
			proSelec(index) {
				if (!this.professionListCheck[index] && this.professionListCount == 3) {
					this.$toast.fail('超过上限');
					return;
				}
				if (!this.professionListCheck[index]) this.professionListCount++;
				else if (this.professionListCount > 0) this.professionListCount--;
				this.$set(this.professionListCheck, `${index}`, !this.professionListCheck[index]);
			},
			checkForm() {
				if (!this.truename) { this.$toast.fail('请输入姓名'); return false; }
				if (!this.professionListCount) { this.$toast.fail('请选择专业领域'); return false; }
				if (!this.teaching_achievements) { this.$toast.fail('请输入教学成果'); return false; }
				if (this.fileList.length == 0) { this.$toast.fail('请选择证件照'); return false; }
				return true
			},
			submit() {
				if (!this.checkForm()) return
				this.imgList = []
				this.loading = true
				for (let i = 0; i < this.fileList.length; i++) {
					if (this.fileList[i].file) {
						let formData = new FormData();//new一个formData事件
						formData.append("file", this.fileList[i].file);
						this.$post('api/common/upload', formData,{
							'Content-Type':'multipart/form-data'
						}).then(res => {
							this.imgList.push(res.data.src)
							if (this.imgList.length == this.fileList.length) {
								this.submitOk()
							}
						})
					} else {
						this.imgList.push(this.fileList[i].url)
						if (this.imgList.length == this.fileList.length) {
							this.submitOk()
						}
					}
				}
			},
			submitOk() {
				this.$post('api/user/applyCertification', {
					type: 2,
					truename: this.truename,
					major_ids: this.professionListIdSelect.join(','),
					teaching_achievements: this.teaching_achievements,
					certificates: this.imgList.toString()
				}).then(res => {
					this.loading = false
					this.$toast('提交成功')
					setTimeout(() => {
						this.$router.go(-1)
					}, 750);
				})
			}
		}
	}
</script>
<style>
	.input:disabled{
		background-color : #fff; 
		color: #333;
		opacity:1;
		-webkit-text-fill-color:#333;
		-webkit-opacity:1;
	}
	textarea:disabled {
		background-color : #fff; 
		color: #333;
		opacity:1;
		-webkit-text-fill-color:#333;
		-webkit-opacity:1;
	}
</style>
<style scoped lang="stylus">
// 专业领域的弹窗
.professionPop
	padding 44px 30px
	.title
		.title-cancel
			font-size 30px
			color #000000
		.title-content
			font-size 34px
			font-weight bold
			color #0A0A0A
			text-align center
		.title-confirm
			font-size 30px
			font-weight bold
			color #DE113C
	.tips
		width 100%
		text-align center
		margin-top 24px
		font-size 24px
		font-weight 500
		color #B1B1B1
	.selectList
		.item
			margin-top 40px
			margin-right 10px
			width 160px
			height 60px
			line-height 60px
			background #FFFFFF
			border 2px solid #B1B1B1
			border-radius 38px
			font-size 28px
			color #000000
			text-align center
		.item-active
			background #FFD6DF !important
			border 2px solid #DE113C !important
			color #DE113C !important
.submitBtn
	width 376px
	height 92px
	line-height 92px
	text-align center
	background-image url('~@/static/images/index/btnBG.png')
	background-size 100% 100%
	background-position center
	font-size: 32px;
	color: #FFFFFF;
.error
	background #FCF6ED
	font-size 24px
	line-height 44px
	padding 16px 30px
	color #DE8C17
.applyForm
	width 100%
	background #FFFFFF
	border-radius 40px 40px 0px 0px
	padding 40px 30px
	padding-top 0
	// margin-top -100px
	.applyForm-title
		img
			width 38px
			height 46px
		.text
			margin-left -26px
			font-size 32px
			font-weight bold
			color #000000
	.applyForm-line
		padding 36px 0
		font-size 28px
		color #232220
		border-bottom 1px solid #E6E6E6
		.right
			text-align right
			font-size 28px
			color #B1B1B1
			.right-item
				min-width 128px
				padding 0 10px
				height 52px
				line-height 52px
				text-align center
				border 2px solid #DE113C
				border-radius 26px
				font-size 28px
				color #DE113C
				margin-right 20px
		.arrow
			width 14px
			height 30px
			margin-left 16px
		input
			text-align right
			font-size 28px
			color #333333
		input::-webkit-input-placeholder
			color #B1B1B1
			font-size 28px
		input::-moz-placeholder /* Mozilla Firefox 19+ */
			color #B1B1B1
			font-size 28px
		input:-moz-placeholder /* Mozilla Firefox 4 to 18 */
			color #B1B1B1
			font-size 28px
		input:-ms-input-placeholder /* Internet Explorer 10-11 */
			color #B1B1B1
			font-size 28px
	.applyForm-col
		padding 36px 0
		border-bottom 1px solid #E6E6E6
		.title
			font-size 28px
			font-weight bold
			color #232220
		.textList
			margin-top 28px
			width 100%
			height 120px
			textarea
				width 100%
				height 100%
				background-color #FFFFFF
				border none
				resize none
				font-size 28px
				color #000000
			textarea::-webkit-input-placeholder
				font-size 28px
				color #B1B1B1
			textarea:-moz-placeholder
				font-size 28px
				color #B1B1B1
			textarea::-moz-placeholder
				font-size 28px
				color #B1B1B1
			textarea::-ms-input-placeholder
				font-size 28px
				color #B1B1B1
	.applyPicTitle
		margin 34px 0
		font-size 28px
		font-weight bold
		color #000000
	.submitBtn
		width 376px
		height 92px
		margin 60px auto
		img
			width 100%
			height 100%
</style>
